import axios from 'axios';
import setupInterceptors from './interceptors';

// Configure axios defaults
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup interceptors for authentication and error handling
setupInterceptors(api, API_BASE_URL);

export default api;